import React from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import SignupPage from "../../components/Signup";
import Footer from "../../components/Footer";

import './Signup.styles.css';

const Signup = () => {

	return (
		<div>
			<Helmet>
				<title>Signup</title>
			</Helmet>
			<Header />
			<SignupPage />
			<Footer />
		</div>
	);
};

export default Signup;